import React from 'react'

const Welcome = () => {
  return (
    <h1 className='amie-logo'>Amie</h1>
  )
}

export default Welcome
